/** Created by azhou on 2019/3/11.*/
<template>
  <div>
    <ul class="list-item">
      <li class="w-30 list-item-col flex-column">
        <span>{{Itemize.adtime | formatTimestamp(1) }}</span>{{Itemize.order_no}}
      </li>
      <li class="w-20 list-item-col">
        <el-popover placement="right" width="200" trigger="hover">
          {{Itemize.truename}}（{{Itemize.branch}}）
          <p class="text-info">{{Itemize.card}}</p>
          <span slot="reference">{{Itemize.bank}}<i class="el-icon-info ml-1"></i></span>
        </el-popover>
      </li>
      <li class="w-15 list-item-col">&yen; {{Itemize.money / 100 | formatMoney}}</li>
      <li class="w-15 list-item-col">&yen; {{Itemize.money_end / 100 | formatMoney}}</li>
      <li class="w-10 list-item-col" :class="[Itemize.status ? 'text-success' : 'text-danger']">{{Itemize.status ? '已提现' : '冻结中'}}</li>
      <li class="w-10 list-item-col">
        <span class="text-link" @click="goWithdrawDetail">查看详情</span>
      </li>
    </ul>
    <el-dialog title="提现详情" :visible.sync="showDetail" center :show-close="false" width="900px">
      <withdraw-detail/>
      <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
    </el-dialog>
  </div>

</template>

<script>
  import { mapGetters,mapActions } from 'vuex'
  import WithdrawDetail from './WithdrawDetail'

  export default {
    name: 'ItemizeAlreadyWithdraw',
    components: { WithdrawDetail },
    props:{
      Itemize:{}
    },
    computed:{
      ...mapGetters(['storeInfo'])
    },
    data() {
      return {
        showDetail:false
      }
    },
    methods:{
      ...mapActions(['getWithdrawDetail']),
      async goWithdrawDetail() {
        await this.getWithdrawDetail({
          store_id:this.storeInfo.storeId,
          store_type:this.storeInfo.type,
          withdraw_id:this.Itemize.id,
        })
        this.showDetail = true;
        /*this.$router.push({
          name:'WithdrawDetail',
          query:{
            wid:this.Itemize.id,
            sid:this.storeInfo.storeId,
            type:this.storeInfo.type,
          }
        })*/
      }
    }
  }
</script>
